import { render, staticRenderFns } from "./EvanSwitch.vue?vue&type=template&id=091bf072&scoped=true"
import script from "./EvanSwitch.vue?vue&type=script&lang=js"
export * from "./EvanSwitch.vue?vue&type=script&lang=js"
import style0 from "./EvanSwitch.vue?vue&type=style&index=0&id=091bf072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091bf072",
  null
  
)

export default component.exports